import { Component, OnInit } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormFieldIonSelectComponent } from "../components/select_component";
import { KreFormIonDialogService } from "../tools/dialog.service";
@Component({
  selector: "kreform-field-ion-select",
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-item detail="true" (click)="openPicker()">
        <div>{{ newTextLookUp }}</div>
      </ion-item>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{ textLookUp }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonSelect extends FieldType {
  constructor(public dialogService: KreFormIonDialogService) {
    super();
  }

  get newTextLookUp() {
    let result = [];
    if (
      this.model &&
      this.model != null &&
      this.model.hasOwnProperty(this.key)
    ) {
      if (
        this.model[this.key] !== undefined &&
        this.model[this.key] != null &&
        this.model[this.key].length > 0
      ) {
        if (this.to.options && (this.to.options as any[]).length > 0) {
          this.model[this.key].forEach((ele) => {
            if (
              (this.to.options as any[]).some((el) => el.value === ele.value)
            ) {
              result.push(ele.label);
            }
          });
        }

        // result = this.model[this.key].map((item: any) => {
        //   return item.label;
        // });
      }
    }
    return result.join("、");
  }

  openPicker() {
    let options = [];
    let selectType = "single";
    if (this.to.selectType && this.to.selectType == "multiple") {
      selectType = "multiple";
    }
    this.to.options.forEach((item: any) => {
      options.push({
        value: item.value,
        label: item.label,
        checked: this.isOptionChecked(item.value),
      });
    });
    let params = {
      options: options,
      selectType: selectType,
    };
    this.dialogService.CreateModelDialog(
      {
        content: KreFormFieldIonSelectComponent,
        class: "part-page",
      },
      params,
      (instance: any, modal: any) => {
        if (instance) {
          this.formControl.patchValue(instance);
          this.formControl.markAsTouched();
        }
      }
    );
  }
}
